import React, {forwardRef} from 'react'
import {AvatarBase} from '@components/common/base/avatar/avatar-base'
import {TwAvatarStack} from '@components/common/base/avatar/containers'
import {cn} from '@containers/html-utils'
import {AvatarStackBaseProps} from './types'

export const AvatarStackBase = forwardRef<HTMLElement, AvatarStackBaseProps>(
  ({users, outlineColor, className}, ref) => (
    <TwAvatarStack ref={ref} className={className}>
      {users.map(user => (
        <AvatarBase
          key={user.userId}
          user={user}
          size={16}
          hideStatus
          hideHint
          outlineColor={outlineColor}
          outlineSize={2}
          className={cn('flex-none', '-ml-8', 'first:ml-0')}
        />
      ))}
    </TwAvatarStack>
  )
)
